import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React, {useEffect} from 'react'
import {NullAsDefault} from 'views/Shared'
import useExamTimer from '../functions/useExamTimer'

const ExamCountdown = ({onInit = NullAsDefault, ...props}) => {
    const t = useTranslate()

    const {
        trigger = false,
        seconds = 0,
        minutes = 0,
        hours = 0,
    } = useExamTimer(props)

    useEffect(() => {
        onInit()
    }, [])

    let bg_class = 'bg-blue-200'
    if (hours === 0 && minutes === 0) {
        bg_class = 'bg-red-200 text-red-600 border-2 border-red-600'
    } else if (hours === 0 && minutes === 1) {
        bg_class = 'bg-orange-100 text-orange-600 border-2 border-orange-600'
    } else {
        bg_class = 'bg-blue-100 text-blue-700 border-2 border-blue-700'
    }

    return (
        <div className="flex items-center gap-2">
            <div
                style={{padding: '3px 5px', width: '36px'}}
                className={classNames(
                    bg_class,
                    'flex flex-col flex-center font-bold rounded-md tracking-wide'
                )}>
        <span className="leading-5 text-lg">
          {trigger ? '00' : hours < 10 ? `0${hours}` : hours}
        </span>
                <span className="text-3xs uppercase">{t('hours')}</span>
            </div>
            <div
                style={{padding: '3px 5px', width: '36px'}}
                className={classNames(
                    bg_class,
                    'flex flex-col flex-center font-bold rounded-md tracking-wide'
                )}>
        <span className="leading-5 text-lg">
          {trigger ? '00' : minutes < 10 ? `0${minutes}` : minutes}
        </span>
                <span className="text-3xs uppercase">{t('minutes')}</span>
            </div>
            <div
                style={{padding: '3px 5px', width: '36px'}}
                className={classNames(
                    bg_class,
                    'flex flex-col flex-center font-bold rounded-md tracking-wide'
                )}>
        <span className="leading-5 text-lg">
          {trigger ? '00' : seconds < 10 ? `0${seconds}` : seconds}
        </span>
                <span className="text-3xs uppercase">{t('seconds')}</span>
            </div>
        </div>
    )
}

export default ExamCountdown
